import { User } from "@/types/generale";

export function convertBooleansToStrings(array: User[]): User[] {
  return array.map((obj) => {
    const newObj: any = { ...obj };
    for (let key in newObj) {
      if (typeof newObj[key] === "boolean") {
        newObj[key] = newObj[key].toString();
      }
    }
    return newObj;
  });
}
